import { create } from 'zustand'

/** Tracks whether the help "peek" modifier (Alt/Option) is currently held.
 *  Flipped only by HelpModeKeyListener; read by useHelpMode. */
export interface HelpModeState {
  peekHeld: boolean
  setPeekHeld: (held: boolean) => void
}

const useHelpModeStore = create<HelpModeState>((set) => ({
  peekHeld: false,
  setPeekHeld: (held) =>
    set((s) => (s.peekHeld === held ? s : { peekHeld: held })),
}))

export default useHelpModeStore
